<script lang="ts">
    import { _ } from "svelte-i18n"
    import { Splide, SplideSlide, SplideTrack } from "@splidejs/svelte-splide"
    import { navigate } from "svelte-routing"
    import { sliderImageCursor } from "../../store"

    import Image from "./Image.svelte"

    export let contents: Content[]
    $: projects = contents
        .filter((c) => c.type.includes("project"))
        .sort((a, b) => {
            const dateA = new Date(a.project?.general?.date || 0)
            const dateB = new Date(b.project?.general?.date || 0)
            return dateB.getTime() - dateA.getTime()
        })

    let scrollY: number = 0
    let isOver: boolean = false
    let posX: number = 0
    let posY: number = 0

    const onMouseMove = (e) => {
        if (isOver) {
            posX = e.clientX
            posY = e.clientY
            $sliderImageCursor.element.style.top = posY + scrollY - 40 + "px"
            $sliderImageCursor.element.style.left = posX - 40 + "px"
        }
    }

    const onMouseLeave = (e) => {
        isOver = false
        $sliderImageCursor.element.style.top = "-999px"
        $sliderImageCursor.element.style.left = "-999px"
        $sliderImageCursor.element.classList.remove("show")
    }

    const onMouseEnter = (e) => {
        if (!isOver) {
            $sliderImageCursor.theme = "default"
            $sliderImageCursor.element.classList.add("show")
        }
        isOver = true
    }

    const onScroll = (e) => {
        if (isOver) {
            $sliderImageCursor.element.style.top = posY + scrollY - 40 + "px"
            $sliderImageCursor.element.style.left = posX - 40 + "px"
        }
    }
</script>

<svelte:window bind:scrollY on:scroll="{onScroll}" />

{#if projects}
    <div on:mouseenter="{onMouseEnter}" on:mouseleave="{onMouseLeave}" on:mousemove="{onMouseMove}">
        <Splide
            class="main-slider"
            aria-label="Main Slider Projects"
            options="{{
                rewind: true,
                perPage: 1,
                width: '100vw',
                fixedWidth: '100vw',
                fixedHeight: '100vh', // Full document height
                pagination: null,
            }}"
            hasTrack="{false}"
        >
            <div class="custom-wrapper">
                <SplideTrack>
                    {#each projects as p}
                        {#if p?.project?.general?.showedInMainSlider}
                            <SplideSlide>
                                <Image
                                    entryId="{p.id}"
                                    file="{p.project?.media?.mainImage}"
                                    cssClass="project-image"
                                    on:click="{() => {
                                        navigate(p.path)
                                        $sliderImageCursor.element.classList.remove('show')
                                    }}"
                                />
                            </SplideSlide>
                        {/if}
                    {/each}
                </SplideTrack>
                <div class="splide__actions">
                    <div class="splide__arrows">
                        <button class="splide__arrow splide__arrow--prev">
                            <div class="gradient"></div>
                            <img src="img/icons/bytesize_chevron-left-white.svg" alt="{$_('back')}" />
                        </button>
                        <button class="splide__arrow splide__arrow--next">
                            <div class="gradient"></div>
                            <img src="img/icons/bytesize_chevron-right-white.svg" alt="{$_('forward')}" />
                        </button>
                    </div>
                </div>
            </div>
        </Splide>
    </div>
{/if}
